var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _g3, _path8, _path9, _path10, _path11, _g4, _path12, _path13, _path14, _path15, _g5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 39,
    viewBox: "0 0 128 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.588379H127.259V38.1597H0V0.588379Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5853_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.817 37.6835H4.80377C2.41217 37.6835 0.474144 35.7386 0.474144 33.3408V5.28246C0.474144 2.88469 2.41217 0.9375 4.80377 0.9375H122.817C125.209 0.9375 127.147 2.88469 127.147 5.28246V33.3408C127.147 35.7386 125.209 37.6835 122.817 37.6835Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 39
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H127.616V38.1598H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5853_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80161 1.41357C2.67574 1.41357 0.946181 3.14925 0.946181 5.28265V33.341C0.946181 35.4744 2.67574 37.2078 4.80161 37.2078H122.817C124.943 37.2078 126.673 35.4744 126.673 33.341V5.28265C126.673 3.14925 124.943 1.41357 122.817 1.41357H4.80161ZM122.817 38.1596H4.80161C2.15344 38.1596 7.62939e-05 35.9986 7.62939e-05 33.341V5.28265C7.62939e-05 2.6251 2.15344 0.464111 4.80161 0.464111H122.817C125.465 0.464111 127.619 2.6251 127.619 5.28265V33.341C127.619 35.9986 125.465 38.1596 122.817 38.1596Z",
    fill: "#A7A9AB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.976 28.8861H102.736V17.0536H100.976V28.8861ZM116.829 21.3158L114.811 26.447H114.751L112.657 21.3158H110.76L113.901 28.4861L112.11 32.4747H113.947L118.785 21.3158H116.829ZM106.845 27.5413C106.27 27.5413 105.466 27.2539 105.466 26.5366C105.466 25.624 106.467 25.2745 107.331 25.2745C108.105 25.2745 108.47 25.4423 108.939 25.6699C108.802 26.7665 107.862 27.5413 106.845 27.5413ZM107.058 21.0583C105.785 21.0583 104.465 21.6215 103.918 22.8699L105.48 23.5227C105.814 22.8699 106.435 22.6561 107.088 22.6561C108 22.6561 108.923 23.2032 108.939 24.1779V24.2998C108.621 24.1182 107.938 23.8423 107.104 23.8423C105.42 23.8423 103.707 24.7711 103.707 26.5067C103.707 28.0907 105.086 29.1114 106.635 29.1114C107.817 29.1114 108.47 28.5781 108.88 27.9528H108.939V28.8677H110.639V24.3297C110.639 22.2307 109.077 21.0583 107.058 21.0583ZM96.1816 22.7572H93.6778V18.6996H96.1816C97.4989 18.6996 98.2434 19.7939 98.2434 20.7273C98.2434 21.6468 97.4989 22.7572 96.1816 22.7572ZM96.1358 17.0536H91.9184V28.8861H93.6778V24.4032H96.1358C98.0876 24.4032 100.005 22.9848 100.005 20.7273C100.005 18.4697 98.0876 17.0536 96.1358 17.0536ZM73.1407 27.5436C71.9242 27.5436 70.9048 26.5228 70.9048 25.1205C70.9048 23.7021 71.9242 22.6652 73.1407 22.6652C74.3411 22.6652 75.2826 23.7021 75.2826 25.1205C75.2826 26.5228 74.3411 27.5436 73.1407 27.5436ZM75.1589 21.9779H75.0993C74.7053 21.5066 73.9447 21.079 72.9872 21.079C70.9804 21.079 69.1432 22.8492 69.1432 25.1205C69.1432 27.378 70.9804 29.1321 72.9872 29.1321C73.9447 29.1321 74.7053 28.7045 75.0993 28.2171H75.1589V28.7942C75.1589 30.3345 74.3411 31.1598 73.017 31.1598C71.938 31.1598 71.2691 30.3804 70.9965 29.7252L69.4616 30.3666C69.9015 31.4333 71.0721 32.7437 73.017 32.7437C75.0833 32.7437 76.8312 31.5253 76.8312 28.5505V21.3227H75.1589V21.9779ZM78.0476 28.8861H79.8115V17.0536H78.0476V28.8861ZM82.4093 24.9826C82.3635 23.4262 83.6097 22.6354 84.5054 22.6354C85.2041 22.6354 85.7974 22.9848 85.9944 23.4883L82.4093 24.9826ZM87.8797 23.64C87.5453 22.7411 86.5282 21.079 84.4435 21.079C82.3795 21.079 80.6614 22.7112 80.6614 25.1044C80.6614 27.3619 82.3635 29.1321 84.6428 29.1321C86.4823 29.1321 87.5453 28.0033 87.9851 27.3459L86.6175 26.4309C86.1616 27.1022 85.5385 27.5436 84.6428 27.5436C83.7471 27.5436 83.108 27.1344 82.6979 26.3251L88.0607 24.0998L87.8797 23.64ZM45.1424 22.3135V24.0216H49.2154C49.094 24.9826 48.7756 25.6837 48.2877 26.1711C47.6966 26.7665 46.7689 27.4217 45.1424 27.4217C42.6362 27.4217 40.6753 25.3941 40.6753 22.879C40.6753 20.3617 42.6362 18.3341 45.1424 18.3341C46.4963 18.3341 47.4836 18.8674 48.2121 19.5548L49.4125 18.3479C48.3953 17.3731 47.0438 16.626 45.1424 16.626C41.7085 16.626 38.822 19.433 38.822 22.879C38.822 26.3251 41.7085 29.1321 45.1424 29.1321C46.9979 29.1321 48.3953 28.5206 49.4903 27.378C50.6128 26.2493 50.9633 24.663 50.9633 23.3825C50.9633 22.9848 50.9336 22.6193 50.8717 22.3135H45.1424ZM55.5931 27.5436C54.3766 27.5436 53.3297 26.5389 53.3297 25.1044C53.3297 23.6561 54.3766 22.6652 55.5931 22.6652C56.8095 22.6652 57.8564 23.6561 57.8564 25.1044C57.8564 26.5389 56.8095 27.5436 55.5931 27.5436ZM55.5931 21.079C53.3733 21.079 51.5658 22.771 51.5658 25.1044C51.5658 27.4217 53.3733 29.1321 55.5931 29.1321C57.8129 29.1321 59.6203 27.4217 59.6203 25.1044C59.6203 22.771 57.8129 21.079 55.5931 21.079ZM64.3783 27.5436C63.1619 27.5436 62.1127 26.5389 62.1127 25.1044C62.1127 23.6561 63.1619 22.6652 64.3783 22.6652C65.5924 22.6652 66.6416 23.6561 66.6416 25.1044C66.6416 26.5389 65.5924 27.5436 64.3783 27.5436ZM64.3783 21.079C62.1585 21.079 60.3511 22.771 60.3511 25.1044C60.3511 27.4217 62.1585 29.1321 64.3783 29.1321C66.5958 29.1321 68.4056 27.4217 68.4056 25.1044C68.4056 22.771 66.5958 21.079 64.3783 21.079Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95367 7.63489C9.67878 7.92455 9.51613 8.37744 9.51613 8.96366V29.8793C9.51613 30.4655 9.67878 30.9184 9.95367 31.208L10.0224 31.277L21.6987 19.5594V19.2835L10.0224 7.56592",
    fill: "#59C9F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 11,
    height: 9
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6989 15.384H31.082V23.5061H21.6989V15.384Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5853_223)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 11,
    height: 9
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6988 19.2809V19.559L25.5909 23.4672L25.678 23.4143L30.2894 20.7867C31.6066 20.0349 31.6066 18.8073 30.2894 18.0555L25.6803 15.4256L25.5909 15.375L21.6988 19.2809Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5853_223)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 11,
    height: 9
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6988 19.2809V19.559L25.5909 23.4672L25.678 23.4143L30.2894 20.7867C31.6066 20.0349 31.6066 18.8073 30.2894 18.0555L25.6803 15.4256L25.5909 15.375L21.6988 19.2809Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5853_223)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.67638,
    height: 8.12164,
    transform: "matrix(1 0 0 -1 21.6402 23.5051)",
    fill: "url(#pattern0_5853_223)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 19,
    width: 17,
    height: 13
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96912 19.4216H25.8032V31.7806H9.96912V19.4216Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5853_223)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 19,
    width: 17,
    height: 13
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95306 31.2082C10.386 31.6703 11.103 31.7255 11.9117 31.2657L25.6772 23.4149L21.698 19.4216L9.95306 31.2082Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5853_223)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 19,
    width: 17,
    height: 13
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95306 31.2082C10.386 31.6703 11.103 31.7255 11.9117 31.2657L25.6772 23.4149L21.698 19.4216L9.95306 31.2082Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_5853_223)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 11,
    width: 29,
    height: 29
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6433 13.6928L3.84106 25.5369L17.799 39.5442L29.6012 27.6979L15.6433 13.6928ZM17.799 11.5295L15.6433 13.6928L29.6012 27.6979L31.7546 25.5369L17.799 11.5295Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_5853_223)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7754,
    height: 12.1825,
    transform: "matrix(1 0 0 -1 9.91014 31.6279)",
    fill: "url(#pattern1_5853_223)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 17,
    height: 13
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96912 7.0625H25.8032V19.4215H9.96912V7.0625Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_5853_223)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 17,
    height: 13
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95316 7.63303L21.6981 19.4219L25.6796 15.4264L11.9118 7.57555C11.5315 7.35945 11.1742 7.2583 10.8557 7.2583C10.4938 7.2583 10.1822 7.38934 9.95316 7.63303Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_5853_223)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 17,
    height: 13
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95316 7.63303L21.6981 19.4219L25.6796 15.4264L11.9118 7.57555C11.5315 7.35945 11.1742 7.2583 10.8557 7.2583C10.4938 7.2583 10.1822 7.38934 9.95316 7.63303Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_5853_223)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_5853_223",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: -1,
    width: 29,
    height: 29
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84104 13.355L11.5863 21.1277L25.5442 7.12261L17.7967 -0.652344L3.84104 13.355ZM11.5863 21.1277L17.7967 27.36L31.7546 13.355L25.5442 7.12261L11.5863 21.1277Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_5853_223)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7754,
    height: 12.1825,
    transform: "matrix(1 0 0 -1 9.91012 19.4456)",
    fill: "url(#pattern2_5853_223)"
  })))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3537 8.30368C42.9987 7.9887 42.5336 7.78638 42.0159 7.78638C40.8568 7.78638 39.9633 8.74742 39.9633 9.92687C39.9633 11.1086 40.8568 12.0605 42.0159 12.0605C43.0147 12.0605 43.7409 11.4788 43.789 10.5568H42.2106V9.90388H44.6412C44.6412 11.8604 43.6034 12.7801 42.0159 12.7801C40.4375 12.7801 39.2142 11.5041 39.2142 9.92687C39.2142 8.34277 40.4375 7.06445 42.0159 7.06445C42.749 7.06445 43.4087 7.34955 43.8921 7.80017",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9521 7.13135V7.83258H46.4139V9.61211H48.6291V10.3156H46.4139V11.9963H49.0323V12.6998H45.6648V7.13135",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.809 7.13135V7.84178H52.1252V12.6998H51.3693V7.84178H49.6855V7.13135",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6517 12.6998H57.4008V7.13135H56.6517V12.6998Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5094 7.13135V7.84178H60.8257V12.6998H60.0674V7.84178H58.3837V7.13135",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7917 12.0536C68.96 12.0536 69.8534 11.1086 69.8534 9.92687C69.8534 8.74742 68.96 7.79328 67.7917 7.79328C66.6325 7.79328 65.7391 8.74742 65.7391 9.92687C65.7391 11.1086 66.6325 12.0536 67.7917 12.0536ZM67.7917 7.06445C69.3792 7.06445 70.6117 8.34277 70.6117 9.92687C70.6117 11.5041 69.3792 12.7801 67.7917 12.7801C66.2133 12.7801 64.99 11.5041 64.99 9.92687C64.99 8.34277 66.2133 7.06445 67.7917 7.06445Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0425 12.6998L72.5135 8.50623V12.6998H71.7644V7.13135H72.5066L75.0105 11.2928V7.13135H75.7596V12.6998",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5853_223",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5853_223",
    transform: "scale(0.00606061 0.00724638)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_5853_223",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5853_223",
    transform: "scale(0.00371747 0.00483092)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_5853_223",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_5853_223",
    transform: "scale(0.00371747 0.00483092)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5853_223",
    width: 165,
    height: 138,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKUAAACKCAIAAABEsx1uAAAABmJLR0QA/wD/AP+gvaeTAAABiklEQVR4nO3RQQrCMBRAwdYLeP/zeC0hXYhotRURCsKbWSWk/Ca8+Xo5T8/m9/XYP7p/sHt0247t08d6fJw/TfNYb3+45HrIxiW/GXLwS18GHuB0+B/4J3q36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLQuvRg30apKsewAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_5853_223",
    width: 269,
    height: 207,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_5853_223",
    width: 269,
    height: 207,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGplay);
export default __webpack_public_path__ + "static/media/gplay.a9555784b7364e2c2e723cf7945191f5.svg";
export { ForwardRef as ReactComponent };